import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const CalendarCallback = () => {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');

        if (error) {
          throw new Error(`OAuth error: ${error}`);
        }

        if (!code || !state) {
          throw new Error('Missing authorization code or state parameter');
        }

        // Parse state to get event details
        const stateData = JSON.parse(atob(state));
        const { event_id, guest_id, provider } = stateData;

        // Exchange code for tokens
        const { data, error: exchangeError } = await supabase.functions.invoke('calendar-oauth', {
          body: {
            action: 'exchange_code',
            code,
            provider,
            redirect_uri: `${window.location.origin}/calendar-callback`,
            event_id,
            guest_id,
          }
        });

        if (exchangeError) {
          throw new Error(exchangeError.message);
        }

        // Notify parent window of success
        window.opener?.postMessage({
          type: 'CALENDAR_OAUTH_SUCCESS',
          data
        }, window.location.origin);

        // Close popup
        window.close();

      } catch (error) {
        console.error('Calendar callback error:', error);
        
        // Notify parent window of error
        window.opener?.postMessage({
          type: 'CALENDAR_OAUTH_ERROR',
          error: error instanceof Error ? error.message : 'Unknown error occurred'
        }, window.location.origin);

        // Close popup
        window.close();
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="w-8 h-8 animate-spin rounded-full border-2 border-primary border-t-transparent mx-auto mb-4" />
        <p className="text-muted-foreground">Completing calendar connection...</p>
      </div>
    </div>
  );
};

export default CalendarCallback;